/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_ZERO_URA_DISPLAY = 'REFRESH_ZERO_URA_DISPLAY';
export const SET_SELECTED_ZERO_URA = 'SET_SELECTED_ZERO_URA';
export const IS_LOADING_ZERO_URA = 'IS_LOADING_ZERO_URA';
export const GET_MANUFACTURER_LIST_ZERO_URA = 'GET_MANUFACTURER_LIST_ZERO_URA';
export const GET_MAX_QUARTER_ZERO_URA = 'GET_MAX_QUARTER_ZERO_URA';
export const GET_ZERO_URA = 'GET_ZERO_URA';
export const REFRESH_ZERO_URA = 'REFRESH_ZERO_URA';
